import { render, staticRenderFns } from "./MidAutumn.vue?vue&type=template&id=52b69133&scoped=true&"
import script from "./MidAutumn.vue?vue&type=script&lang=js&"
export * from "./MidAutumn.vue?vue&type=script&lang=js&"
import style0 from "./MidAutumn.vue?vue&type=style&index=0&id=52b69133&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b69133",
  null
  
)

export default component.exports